/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskAcctCompileOrReviewBasis
 */
export interface ExecRiskAcctCompileOrReviewBasis {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAcctCompileOrReviewBasis
     */
    separate_basis_fincl_stmt_ind?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAcctCompileOrReviewBasis
     */
    consolidated_basis_fincl_stmt_ind?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAcctCompileOrReviewBasis
     */
    consol_and_sep_basis_fincl_stmt_ind?: string;
}

/**
 * Check if a given object implements the ExecRiskAcctCompileOrReviewBasis interface.
 */
export function instanceOfExecRiskAcctCompileOrReviewBasis(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskAcctCompileOrReviewBasisFromJSON(json: any): ExecRiskAcctCompileOrReviewBasis {
    return ExecRiskAcctCompileOrReviewBasisFromJSONTyped(json, false);
}

export function ExecRiskAcctCompileOrReviewBasisFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskAcctCompileOrReviewBasis {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'separate_basis_fincl_stmt_ind': !exists(json, 'separate_basis_fincl_stmt_ind') ? undefined : json['separate_basis_fincl_stmt_ind'],
        'consolidated_basis_fincl_stmt_ind': !exists(json, 'consolidated_basis_fincl_stmt_ind') ? undefined : json['consolidated_basis_fincl_stmt_ind'],
        'consol_and_sep_basis_fincl_stmt_ind': !exists(json, 'consol_and_sep_basis_fincl_stmt_ind') ? undefined : json['consol_and_sep_basis_fincl_stmt_ind'],
    };
}

export function ExecRiskAcctCompileOrReviewBasisToJSON(value?: ExecRiskAcctCompileOrReviewBasis | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'separate_basis_fincl_stmt_ind': value.separate_basis_fincl_stmt_ind,
        'consolidated_basis_fincl_stmt_ind': value.consolidated_basis_fincl_stmt_ind,
        'consol_and_sep_basis_fincl_stmt_ind': value.consol_and_sep_basis_fincl_stmt_ind,
    };
}

